import React from "react"
import { useHistory } from "react-router-dom"
import moment from 'moment';
import 'moment/locale/zh-tw';

import { Row, Col, Button } from 'antd'

import config from '../config'

import logoWhite from '../assets/images/image_logo_new_white_event.png'
import arrowIcon from '../assets/images/icon_arrow_right_bold.png'
import heartIcon from '../assets/images/icon_heart.png'
import rewardIcon from '../assets/images/icon_reward.png'
import whistleIcon from '../assets/images/icon_whistle.png'

const imgBaseUrl = config.firebase.getImageUrl()

const signupImg = `${imgBaseUrl}/Events%2FCommon%2Fimg_signup.png?alt=media`
const durationBG = `${imgBaseUrl}/Events%2FCommon%2FBG_duration.png?alt=media`
const durationBGMobile = `${imgBaseUrl}/Events%2FCommon%2FBG_duration_Mobile.png?alt=media`
const hostBG = `${imgBaseUrl}/Events%2FCommon%2Fimg_host_bg.jpg?alt=media`
const buyImg = `${imgBaseUrl}/Events%2FCommon%2Fimg_buy.png?alt=media`


export default function EventMaster(props) {
    const history = useHistory()
    const { event } = props

    moment.locale('zh-tw')

    const createMarkup = (content) => {
        let str = String(content)
        let re = /(\r\n)|(\n)/g
        let reLink = /(https?:\/\/[\w\-/.?=&#]+)/g

        let newStr = str.replace(re, "<br>").replace(reLink, "<a href='$1'>$1</a>")
        return { __html: newStr }
    }

    const handleSignup = () => {
        history.push('/list')
    }

    const LeaderBoardButton = () => {
        const hideLink = moment().isBefore(event.leaderBoard.opening)

        return (
            <Button className="event-duration-btn" disabled={hideLink}>
                {
                    hideLink ? `將於${moment(event.leaderBoard.opening).format('M/DD')}開啟`
                        : <a href={event.leaderBoard.link}>點我觀看</a>
                }
            </Button>
        )
    }

    return (
        <div>
            <img src={event.backgroundImgUrl} className="event-background-img" alt="background" />
            <img src={event.backgroundMobileImgUrl} className="event-background-mobile-img" alt="background" />

            {/* Header Logo */}
            <Row type="flex" justify="space-between" align="middle" className="event-header">
                <Col className="event-header-logo-co-organizer">
                    <img src={event.headerLogoWhiteImgUrl} className="web-img" alt="logo" />
                </Col>

                <Col className="event-header-logo">
                    <a href="/">
                        <img src={logoWhite} className="web-img" alt="logo" />
                    </a>
                </Col>
            </Row>

            {/* Title */}
            <Row type="flex" justify="end">
                <Col className="event-signup">
                    <Row type="flex" justify="center">
                        {/* PC */}
                        <p className="event-signup-title">
                            {event.title}
                        </p>

                        {/* Mobile */}
                        <div
                            className="event-signup-title-mobile"
                            dangerouslySetInnerHTML={createMarkup(event.titleMobile)}
                        />
                    </Row>
                    <Row type="flex" justify="center">
                        {/* PC */}
                        <p className="event-signup-sub-title">
                            {event.subTitle}
                        </p>

                        {/* Mobile */}
                        <div
                            className="event-signup-sub-title-mobile"
                            dangerouslySetInnerHTML={createMarkup(event.subTitleMobile)}
                        />
                    </Row>
                    <Row type="flex" justify="center">
                        <button className="event-signup-btn" onClick={() => handleSignup()}>
                            <img src={signupImg} className="web-img" alt="signup" />
                        </button>
                    </Row>
                </Col>
            </Row>


            {/* Discription */}
            <div className="event-description">
                <Row>
                    <img src={rewardIcon} className="event-description-award-icon" alt="award" />
                    {/* PC */}
                    <p className="event-description-title">{event.description.title}</p>

                    {/* Mobile */}
                    <div
                        className="event-description-title-mobile"
                        dangerouslySetInnerHTML={createMarkup(event.description.titleMobile)}
                    />

                    <div className="event-description-subTitle" dangerouslySetInnerHTML={createMarkup(event.description.subTitle)} />
                    <div className="event-description-content1" dangerouslySetInnerHTML={createMarkup(event.description.content1)} />
                    <div className="event-description-content2" dangerouslySetInnerHTML={createMarkup(event.description.content2)} />
                    <div className="event-description-content2-mobile" dangerouslySetInnerHTML={createMarkup(event.description.content2Mobile)} />
                </Row>
            </div>

            {/* Reward */}
            <Row type="flex" justify="center" className="event-rewards">
                <Row type="flex" justify="center" align="bottom">
                    {/* PC */}
                    <p className="event-rewards-title">{event.rewards.title}</p>
                    <p className="event-rewards-title-number ">{event.rewards.titleNumber}</p>

                    {/* Mobile */}
                    <div className="event-rewards-title-mobile" dangerouslySetInnerHTML={createMarkup(event.rewards.titleMobile)} />
                </Row>
                <p className="event-rewards-subTitle">{event.rewards.subTitle}</p>

                <Row className="event-rewards-content-frame">
                    <div className="event-rewards-content" dangerouslySetInnerHTML={createMarkup(event.rewards.content)} />
                    <div className="event-rewards-content-mobile" dangerouslySetInnerHTML={createMarkup(event.rewards.contentMobile)} />
                </Row>
            </Row>

            {/* Welfare */}
            <div className="event-welfare">
                <img src={heartIcon} className="event-welfare-heart-icon" alt="heart" />
                <Row>
                    <p className="event-welfare-title">{event.welfare.title}</p>
                </Row>
                <Row className="event-welfare-content-frame">
                    <div className="event-welfare-content" dangerouslySetInnerHTML={createMarkup(event.welfare.content)} />
                </Row>
            </div>

            {/* Duration & Leaderboard */}
            {/* PC */}
            <Row type="flex" justify="center" className="event-duration">
                <img src={durationBG} className="event-duration-background" alt="backgrond" />

                <Col span={12}>
                    <p className="event-duration-title">比賽日期</p>
                    <div className="event-duration-content" dangerouslySetInnerHTML={createMarkup(event.duration)} />
                </Col>

                <Col span={12}>
                    <p className="event-duration-title">比賽排行榜</p>
                    <LeaderBoardButton />
                </Col>
            </Row>
            {/* Mobile */}
            <Row type="flex" justify="center" className="event-duration-mobile">
                <img src={durationBGMobile} className="event-duration-background" alt="backgrond" />
                <Col span={24} className="event-duration-content-frame">
                    <p className="event-duration-title">比賽日期</p>
                    <div className="event-duration-content" dangerouslySetInnerHTML={createMarkup(event.duration)} />
                </Col>

                <Col span={24} className="event-duration-content-frame">
                    <p className="event-duration-title">比賽排行榜</p>
                    <LeaderBoardButton />
                </Col>
            </Row>

            {/* Teams */}
            <Row type="flex" justify="start" className="event-teams">
                <Col className="event-teams-whistle-img">
                    <img src={whistleIcon} className="web-img" alt="whistle" />
                </Col>
                <Col className="event-teams-title-frame">
                    <p>{event.teams.title}</p>
                </Col>

                <Col className="event-teams-whistle-img">
                </Col>
                <Col className="event-teams-content-frame">
                    <div dangerouslySetInnerHTML={createMarkup(event.teams.content)} />
                </Col>
            </Row>

            <Row type="flex" justify="center">
                <Col xs={5} lg={8}>
                    <hr />
                </Col>
                <Col xs={12} lg={7}>
                    <p className="event-teams-join-title">點選下方隊伍加入</p>
                </Col>
                <Col xs={5} lg={8}>
                    <hr />
                </Col>
            </Row>

            <Row type="flex" justify="start" className="event-teams-leaders">
                {event.teams.leaders.map((leader, index) => (
                    <Col xs={12} lg={6} key={index}>
                        <a href={leader.link}>
                            <Row type="flex" justify="center" >
                                <img src={leader.imgUrl} className="event-teams-leader-avatar" alt={leader} />
                            </Row>
                            <Row type="flex" justify="center" >
                                <p className="event-teams-leader-name">{leader.name}</p>
                            </Row>
                            <Row type="flex" justify="center" >
                                <p className="event-teams-leader-team">{leader.team}</p>
                            </Row>
                        </a>
                    </Col>
                ))}
            </Row>

            {/* Host */}
            <div className="event-host">
                <Row type="flex" justify="center">
                    <Col className="event-host-icon-frame">
                        <img src={event.host.hostIconUrl} className="web-img" alt="icon" />
                    </Col>
                </Row>
                <Row type="flex" justify="center">
                    <p className="event-host-description">{event.host.description}</p>
                    <div className="event-host-description-mobile" dangerouslySetInnerHTML={createMarkup(event.host.durationMobile)} />
                </Row>
                <Row type="flex" justify="center" style={{ position: "relative" }}>
                    <Col className="event-host-img-frame">
                        <a href={event.host.hostLink} target="_blank" rel="noopener noreferrer">
                            <img src={event.host.imgUrl} className="web-img" alt="img" />
                        </a>
                    </Col>
                    <Col className="event-host-img-frame-mobile">
                        <a href={event.host.hostLink} target="_blank" rel="noopener noreferrer">
                            <img src={event.host.imgUrlMobile} className="web-img" alt="img" />
                        </a>
                    </Col>
                    <img src={hostBG} className="event-host-img-bg" alt="background" />
                </Row>
            </div>

            {/* Steps */}
            <div className="event-steps">
                <Row type="flex" justify="center">
                    <Col xs={4} lg={7}>
                        <hr />
                    </Col>
                    <Col xs={13} lg={7}>
                        <p className="event-steps-title">{event.steps.title}</p>
                    </Col>

                    <Col xs={4} lg={7}>
                        <hr />
                    </Col>
                </Row>
                <Row type="flex" justify="space-around" className="event-steps-flows-frame">
                    {event.steps.flowImgs.map((step, index) => (
                        <Col xs={24} lg={index + 1 < event.steps.flowImgs.length ? 6 : 5} key={index}>
                            <Row type="flex" justify="space-between" align="middle" className="event-steps-PC">
                                <Col span={22}>
                                    <Row type="flex" justify="center">
                                        <p className="event-steps-flow-index">{step.number}</p>
                                    </Row>
                                    <img src={step.imgUrl} className="event-steps-flow-img" alt="step" />
                                    <div className="event-steps-flow-title" dangerouslySetInnerHTML={createMarkup(step.title)} />
                                </Col>
                                <Col className={index + 1 < event.steps.flowImgs.length ? "event-steps-arrow-icon-frame" : "web-hidden"}>
                                    <img src={arrowIcon} className="event-steps-arrow-icon" alt="arrow" />
                                </Col>
                            </Row>

                            <Row type="flex" justify="center" className="event-steps-mobile">
                                <Col span={24}>
                                    <div className="event-steps-flow-title" dangerouslySetInnerHTML={createMarkup(step.titleMobile)} />
                                    <img src={step.imgUrl} className="event-steps-flow-img" alt="step" />
                                </Col>
                                <Col className={index + 1 < event.steps.flowImgs.length ? "event-steps-arrow-icon-frame" : "web-hidden"}>
                                    <img src={arrowIcon} className="event-steps-arrow-icon" alt="arrow" />
                                </Col>
                            </Row>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Products */}
            <Row type="flex" justify="center" className="event-products">
                <Col span={24}>
                    <p className="event-products-title ">{event.products.title}</p>
                </Col>
                <Col span={24}>
                    <p className="event-products-sub-title">{event.products.subTitle}</p>
                    <div className="event-products-sub-title-mobile" dangerouslySetInnerHTML={createMarkup(event.products.subTitleMobile)} />
                </Col>
                {event.products.items.map((item, index) => (
                    <Col span={24} key={index} style={{ marginBottom: "3.5vw" }}>
                        <img src={item} className="web-img" alt="product" />
                    </Col>
                ))}
                <button className="event-products-buy-btn" disabled>
                    <img src={buyImg} className="web-img" alt="buy" />
                </button>
            </Row>

            {/* Co-organizer */}
            <Row type="flex" justify="center" className="event-co-organizer">
                <Col xs={6} lg={8}>
                    <hr />
                </Col>
                <Col xs={8} lg={5}>
                    <p className="event-co-organizer-title">{event.coOrganizer.title}</p>
                </Col>
                <Col xs={6} lg={8}>
                    <hr />
                </Col>
                <Col className="event-co-organizer-image-frame">
                    <img src={event.coOrganizer.imgUrls} className="web-img" alt="co-organizer" />
                </Col>

                <Col className="event-co-organizer-image-mobile-frame">
                    <img src={event.coOrganizer.imgUrlsMobile} className="web-img" alt="co-organizer" />
                </Col>
            </Row>

            {/* co-operative-unit */}
            <Row type="flex" justify="center" className="event-co-operative">
                <Col xs={6} lg={8}>
                    <hr />
                </Col>
                <Col xs={8} lg={5}>
                    <p className="event-co-operative-title">{event.coOperativeUnit.title}</p>
                </Col>
                <Col xs={6} lg={8}>
                    <hr />
                </Col>
                <Col className="event-co-operative-image-frame">
                    <img src={event.coOperativeUnit.imgUrls} className="web-img" alt="co-organizer" />
                </Col>

                <Col className="event-co-operative-image-mobile-frame">
                    <img src={event.coOperativeUnit.imgUrlsMobile} className="web-img" alt="co-organizer" />
                </Col>
            </Row>

        </div>
    )
}